import TableData from "./tabledata"

// Luokka, joka sisältää datatyypin kaikille oikean slotin erityyppisille sisällöille.
export default class DynamicRightSlotData {
    constructor(
        id: string,
        municipality: string | null = null,
        mapArea: number | null = null,
        dataUpdatedDate: string | null = null, // TODO OKo: Vaihda tarvittaessa
        textContent: string | null = null,
        tableData: TableData | null = null,
        filters: Map<string, string> | null = null,
        starRating: number | null = null,
        kuvaus: string | null = null,
        linkki: string | null = null,
        description: string | null = null,
        infomapDetails: { textContent: string | null | undefined, link: string | null | undefined }[] | null = [],
        frequencies: string[] | null = [],
        messageFromApi: string | null = null) {
            this.id = id
            this.municipality = municipality
            this.mapArea = mapArea
            this.dataUpdatedDate = dataUpdatedDate
            this.textContent = textContent
            this.tableData = tableData
            this.starRating = starRating
            this.filters = filters
            this.kuvaus = kuvaus
            this.linkki = linkki
            this.description = description
            this.infomapDetails = infomapDetails
            this.frequencies = frequencies
            this.messageFromApi = messageFromApi
        }

    id: string
    municipality: string | null
    mapArea: number | null
    dataUpdatedDate: string | null
    textContent: string | null
    tableData: TableData | null
    starRating: number | null
    filters: Map<string, string> | null
    kuvaus: string | null
    linkki: string | null
    description: string | null
    infomapDetails: { textContent: string | null | undefined, link: string | null | undefined }[] | null
    frequencies: string[] | null
    messageFromApi: string | null

    toJsonObject(): any {
        return {
            id: this.id,
            municipality: this.municipality,
            mapArea: this.mapArea,
            dataUpdatedDate: this.dataUpdatedDate,
            textContent: this.textContent,
            tableData: this.tableData,
            starRating: this.starRating,
            filters: this.filters,
            kuvaus: this.kuvaus,
            linkki: this.linkki,
            description: this.description,
            infomapDetails: this.infomapDetails,
            frequencies: this.frequencies,
            messageFromApi: this.messageFromApi
        }
    }

    static empty(): any {
        return new DynamicRightSlotData("")
    }
}
